module.exports = __webpack_public_path__ + "static/media/eWarren.bda039e4.jpeg";